import { format } from 'date-fns';
import { API } from '../api';
import { exportCSVData } from '../common/exportCSVData';
import { DATE_FORMAT_CSV } from '../commonConst';
import { IUpdateSiteRap, ISiteRap } from './interface';

export const exportSiteRapsTemplate = async (companyId: number) => {
    const query = new URLSearchParams({
        companyId: companyId.toString(),
    });

    const response = await API.fetch(`/sites/raps/template?${query}`, {
        headers: {
            'Content-Type': 'text/csv',
        },
    });

    const respBody: string = await response.text();

    if (response.ok) {
        const fileName = `site-raps-${companyId}-${format(new Date(), DATE_FORMAT_CSV)}.csv`;

        exportCSVData(respBody, fileName);
    } else {
        const respBody: any = await response.json();
        throw new Error(respBody?.error?.message || `Cannot get template!`);
    }
};

export const fetchSiteRap = async (siteId: number): Promise<ISiteRap> => {
    const path = `/sites/${siteId}/raps`;

    const response = await API.fetch(path, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (response.ok) {
        return await response.json();
    }

    const respBody = await response.json();
    throw new Error(respBody.message || 'Failed to fetch Site RAP');
};

export const upsertSiteRap = async ({ site_id, ...dto }: IUpdateSiteRap): Promise<ISiteRap> => {
    const path = `/sites/${site_id}/raps`;

    const response = await API.fetch(path, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(dto),
    });

    if (response.ok) {
        return await response.json();
    }

    const respBody = await response.json();
    throw new Error(respBody.error.message || 'Failed to update Site RAP');
};
